import { ZIndex } from '@opallabs/gem'
import {
  DotLoader,
  DeprecatedSingleSelect,
  CascadingSingleSelect,
} from '@opallabs/lapidary'
import * as styles from '../styles'
import type { UseAddToPlanStateValue } from '../types'
import {
  ConfigureTypesMessage,
  OnPlanMessage,
  StampedMomentsMessage,
} from './ValidationMessages'

type ModalContent = UseAddToPlanStateValue & {
  momentCount: number
}

export const ModalContent: React.FC<ModalContent> = ({
  actions,
  availableOptions,
  loadingStates,
  momentCount,
  selectedOptions,
  validation,
}) => {
  if (loadingStates.isInitialLoading) {
    return (
      <div css={styles.loader}>
        <DotLoader
          height={styles.getLoaderHeight({
            momentCount,
            validation,
          })}
        />
      </div>
    )
  }

  if (validation.momentStamps.length === momentCount) {
    return (
      <StampedMomentsMessage
        momentStamps={validation.momentStamps}
        singleSelection={momentCount === 1}
      />
    )
  }

  if (validation.isOnPlan) {
    return <OnPlanMessage planTitle={validation.planTitle} />
  }

  if (availableOptions.categoryTypeOptions.length === 0) {
    return <ConfigureTypesMessage />
  }

  return (
    <>
      <StampedMomentsMessage
        momentStamps={validation.momentStamps}
        singleSelection={momentCount === 1}
      />
      <CascadingSingleSelect
        initialSelection={selectedOptions.selectedPlanItem ?? undefined}
        items={availableOptions.planItemOptions}
        label="Plan"
        onSelect={actions.setSelectedPlanItem}
        selectedItem={selectedOptions.selectedPlanItem ?? undefined}
        zIndex={ZIndex.Shroud.Popover}
      />
      {loadingStates.isSwimlanesLoading ? (
        <div css={styles.loader}>
          <DotLoader height={styles.heightValues.singleSelect} />
        </div>
      ) : (
        <>
          {selectedOptions.selectedPlanItem &&
            Boolean(availableOptions.swimlaneOptions.length) && (
              <CascadingSingleSelect
                initialSelection={selectedOptions.selectedSwimlane ?? undefined}
                items={availableOptions.swimlaneOptions}
                label="Swimlane (Optional)"
                onSelect={actions.setSelectedSwimlane}
                selectedItem={selectedOptions.selectedSwimlane ?? undefined}
                zIndex={ZIndex.Shroud.Popover}
              />
            )}
        </>
      )}
      {availableOptions.categoryTypeOptions.length > 1 && (
        <DeprecatedSingleSelect
          label="Type"
          options={availableOptions.categoryTypeOptions}
          onChange={actions.setSelectedCategoryType}
        />
      )}
    </>
  )
}
